export default __webpack_public_path__ + "static/media/right.b0c268e7.png";